const wabaChatsTypes = {
    GET_CONVERSATIONS_PENDING: "WABA_GET_CONVERSATIONS_PENDING",
    GET_CONVERSATIONS_SUCCESS: "WABA_GET_CONVERSATIONS_SUCCESS",
    GET_CONVERSATIONS_ERROR: "WABA_GET_CONVERSATIONS_ERROR",
    GET_MESSAGES_PENDING: "WABA_GET_MESSAGES_PENDING",
    GET_MESSAGES_SUCCESS: "WABA_GET_MESSAGES_SUCCESS",
    GET_MESSAGES_ERROR: "WABA_GET_MESSAGES_ERROR",
    LOAD_MORE_MESSAGES_SUCCESS: "WABA_LOAD_MORE_MESSAGES_SUCCESS",
    POLL_NEW_MESSAGES_SUCCESS: "WABA_POLL_NEW_MESSAGES_SUCCESS",
    SEND_MESSAGE_OPTIMISTIC: "WABA_SEND_MESSAGE_OPTIMISTIC",
    SEND_MESSAGE_SUCCESS: "WABA_SEND_MESSAGE_SUCCESS",
    SEND_MESSAGE_ERROR: "WABA_SEND_MESSAGE_ERROR",
    SET_ACTIVE_CONVERSATION: "WABA_SET_ACTIVE_CONVERSATION",
    MARK_READ_SUCCESS: "WABA_MARK_READ_SUCCESS",
    CLEAR_MESSAGES: "WABA_CLEAR_MESSAGES",
    CLEAR_ALL: "WABA_CLEAR_ALL",
    DISMISS_MESSAGE_SUCCESS: "WABA_DISMISS_MESSAGE_SUCCESS",
}
export default wabaChatsTypes
